import type { PropsWithChildren } from 'react';
import type { OptionTypeBase, Props as ReactSelectProps } from 'react-select';

import { Tag, type TagProps } from '@frontend/legacy-components';

export type MultiValueContainerProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = PropsWithChildren<{
  innerProps: TagProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectProps: ReactSelectProps<OptionType, IsMulti>;
}>;

export const MultiValueContainer = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  children,
  innerProps,
}: MultiValueContainerProps<OptionType, IsMulti>) => (
  <Tag {...innerProps}>{children}</Tag>
);
